import { getThirdPartLoginHeader } from '@/lib/business'
import { axios, securityAxios } from '@/utils/axios'

// 获取第三方登录平台
export function loginPlatforms() {
  return axios({
    url: '/common/loginPlatforms'
  })
}
// 第三方登录认证地址
export function getAuthurl(data) {
  return axios({
    url: `/common/authUrl/${data}`
  })
}

// 修改密码
export function changePwd(data) {
  return securityAxios.post(`/user/changepwd`, data)
}

// 验证码
export function vertifyCode(data) {
  return securityAxios.post(`/common/verifycode`, data)
}

export function commonVerify(data) {
  return securityAxios.post('/common/verify', data, {
    headers: {
      silent: true
    }
  })
}

// 获取登录配置
export function loginConfig() {
  return axios.get('/common/loginConfig')
}

// 获取用户基础信息
export function getUserBase() {
  return axios.get('/user/base')
}

// 注册--邮件链接注册检测地址
export function checkEmailLinkeRegistResult(key) {
  return axios.post('/user/linkRegist?key=' + key, null, {
    headers: {
      silent: true
    }
  })
}

// 注册--邮件链接注册提交地址
export function registerByLink(data) {
  return securityAxios.post('/common/verifyLink', data)
}

// 代理注册--邮件链接注册提交地址
export function verifyAgentLink(params) {
  // return securityAxios.post('/common/verifyAgentLink', data)
  return axios.post('/common/verifyAgentLink', params, {
    headers: {
      'Content-Type': 'application/json' // 明确指定 JSON 格式
    }
  })
}

// 代理注册--邮件链接注册检测地址
export function checkIbEmailLinkeRegistResult(key) {
  return axios.post('/user/linkApplyAgent?key=' + key, null, {
    headers: {
      silent: true
    }
  })
}

// 忘记密码验证账号是否存在
export function verifyAccountExist(data) {
  return securityAxios.post('/common/verifyAccount', data, {
    headers: {
      silent: true
    }
  })
}

export function loginSystemConfig() {
  return axios({
    url: '/system/config',
    method: 'get',
    headers: getThirdPartLoginHeader()
  })
}

// 修改用户交易账号登录状态
export function updateUserLoginStatus(status) {
  return axios.post(`/user/updateTaLoginStatus?taLoginStatus=${status}`)
}

// 获取隐私政策和用户服务协议
export function getPolicySetting(data) {
  return axios.post('/system/riskAgreementSetting/list', data)
}

// 登陆邮箱验证
export function userTradeCheckEmail(data) {
  return securityAxios.post('/user/trade/checkEmail', data, {
    headers: {
      silent: true
    }
  })
}

// 邮箱绑定接口
export function userTradeBindEmail(data) {
  return securityAxios.post('/user/trade/bindEmail', data, {
    headers: {
      silent: true
    }
  })
}

export function checkInviteCode(data) {
  return axios.post(`/common/spreadLink/checkInviteCode?inviteCode=${data}`)
}
